export const FETCH_AUTH_INTEROP_USERS = 'FETCH_AUTH_INTEROP_USERS' as const;
export const FETCH_AUTH_INTEROP_USERS_SUCCESS = 'FETCH_AUTH_INTEROP_USERS_SUCCESS' as const;
export const FETCH_AUTH_INTEROP_USERS_FAIL = 'FETCH_AUTH_INTEROP_USERS_FAIL' as const;
export const FETCH_AUTH_INTEROP_USERS_CANCEL = 'FETCH_AUTH_INTEROP_USERS_CANCEL' as const;

export const SAVE_AUTH_INTEROP_USER = 'SAVE_AUTH_INTEROP_USER' as const;
export const SAVE_AUTH_INTEROP_USER_SUCCESS = 'SAVE_AUTH_INTEROP_USER_SUCCESS' as const;
export const SAVE_AUTH_INTEROP_USER_FAIL = 'SAVE_AUTH_INTEROP_USER_FAIL' as const;
export const SAVE_AUTH_INTEROP_USER_CANCEL = 'SAVE_AUTH_INTEROP_USER_CANCEL' as const;

export const DELETE_AUTH_INTEROP_USER = 'DELETE_AUTH_INTEROP_USERS' as 'DELETE_AUTH_INTEROP_USER';
export const DELETE_AUTH_INTEROP_USER_SUCCESS = 'DELETE_AUTH_INTEROP_USER_SUCCESS' as const;
export const DELETE_AUTH_INTEROP_USER_FAIL = 'DELETE_AUTH_INTEROP_USER_FAIL' as const;
export const DELETE_AUTH_INTEROP_USER_CANCEL = 'DELETE_AUTH_INTEROP_USER_CANCEL' as const;

export const FETCH_AUTH_INTEROP_ANALYSIS = 'FETCH_AUTH_INTEROP_ANALYSIS' as const;
export const FETCH_AUTH_INTEROP_ANALYSIS_SUCCESS = 'FETCH_AUTH_INTEROP_ANALYSIS_SUCCESS' as const;
export const FETCH_AUTH_INTEROP_ANALYSIS_FAIL = 'FETCH_AUTH_INTEROP_ANALYSIS_FAIL' as const;
export const FETCH_AUTH_INTEROP_ANALYSIS_CANCEL = 'FETCH_AUTH_INTEROP_ANALYSIS_CANCEL' as const;
